import { useQuery } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { fetchRefundImage } from "../repo/ticketRefundRepo";

/** 私有图片对象 URL 随页面释放，原图不进入持久缓存。 */
export function useRefundImage(teamId: string, id: string, kind: "ticket" | "refund", submissionId?: string) {
  const query = useQuery({ queryKey: ["ticket-refund-image", teamId, id, kind, submissionId], queryFn: () => fetchRefundImage(teamId, id, kind, submissionId), gcTime: 0, retry: false });
  const [url, setUrl] = useState("");
  useEffect(() => {
    if (!query.data) return;
    const next = URL.createObjectURL(query.data);
    setUrl(next);
    return () => URL.revokeObjectURL(next);
  }, [query.data]);
  return { ...query, url };
}
